import React, { useEffect } from "react";
//import logo
// import Logo from '../assets/images//Logo (1).png'
import SmallLogo from '../assets/images/PostHubb-logo.svg'
// Import Components
import VerticalLayout from "./VerticalLayouts/index.js";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import HorizontalLayout from "./HorizontalLayout/index.js";
import SimpleBar from "simplebar-react";

const Sidebar = ({ layoutType }) => {

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');

    const handleChange = (e) => {
      if (e.matches) {
        document.body.classList.add('menu_expanded');
      } else {
        document.body.classList.remove('menu_expanded');
      }
    };

    handleChange(mediaQuery);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      document.body.classList.remove('menu_expanded');
    };
  }, []);

  useEffect(() => {
    let verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  useEffect(() => {
    let menuFolded = document.getElementsByClassName("menu_folded_holder");
    if (menuFolded) {
      menuFolded[0].addEventListener("click", function () {
        document.body.classList.toggle("menu_expanded");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div style={{ backgroundColor: '#fff' }} className="app-menu navbar-menu">
        <div className="menu_folded_holder">
          <i className="ri-menu-fold-line"></i>
        </div>
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm small_logo">
              <img src={SmallLogo} alt="" height="18" />
            </span>
            <span className="logo-lg admin_logo">
              <img src={SmallLogo} alt="" height="60" />
            </span>
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
